import { Autocomplete, TextField } from '@mui/material'
import { InputHelperText } from 'ra-ui-materialui'
import { useCallback, useState } from 'react'
import { useInput, useTranslate } from 'react-admin'

export const AutocompleteFreeSolo = ({
  source,
  record,
  getChoices,
  choices,
  label = '',
  loading,
  helperText,
  autoFocus,
  ...rest
}) => {
  const [open, setOpen] = useState(false)
  const translate = useTranslate()

  // react-admin 5's useInput returns react-hook-form's field/fieldState
  // rather than final-form's input/meta.
  const {
    field,
    isRequired,
    fieldState: { error, isTouched },
  } = useInput({
    source,
    ...rest,
  })

  // The value itself, not the event: react-hook-form reads event.target.value,
  // and a picked suggestion is an <li>, whose `value` is the number 0 — so
  // "Mobil" became 0. (The setValue that followed used the short source, which
  // inside a list row — 'type' of 'phones.0.type' — set the wrong field.)
  const change = useCallback((_, value) => field.onChange(value ?? null), [field])

  return (
    <>
      <Autocomplete
        freeSolo
        autoSelect
        autoHighlight
        onOpen={() => {
          setOpen(true)
          getChoices && getChoices()
        }}
        onClose={() => {
          setOpen(false)
        }}
        open={open}
        loading={loading}
        options={choices}
        openOnFocus={true}
        {...field}
        onChange={change}
        renderInput={(params) => (
          <TextField
            {...params}
            required={isRequired}
            error={!!(isTouched && error)}
            label={translate(label, { _: label })}
            variant='filled'
            margin='dense'
            autoFocus={autoFocus}
            helperText={<InputHelperText error={error?.message} helperText={helperText} />}
          />
        )}
      />
    </>
  )
}

export default AutocompleteFreeSolo
